import React, { useState, useEffect } from 'react';
import Axios from "axios";
import './../../../../assets/css/purchase/form.css';

// React DateTime
import Datetime from 'react-datetime';
import moment from 'moment';

// Components
import Breadcrumbs from '../../../components/Breadcrumbs';
import ArModal from '../../../components/Modal/ArModal';
import ItemWhTable from '../../../components/Content/ItemWhTable';
import FormAction from '../../../components/Actions/FormAction';

// Model
import { whDocMasterModel } from '../../../../model/Warehouse/WHDocMasterModel';
import { whDocDetailModel } from '../../../../model/Warehouse/WHDocDetailModel';

import {
  getData,
  getDataWithComp,
  formatCurrency,
  getMaxIbNo,
  getAlert,
  deleteData,
  randomDelay,
  parseCurrency
} from "../../../../utils/SamuiUtils";

import {
  formatDateTime,
  formatThaiDateUi,
  formatDateOnChange,
  formatStringDateToDate,
  formatThaiDateUiToDate,
  setCreateDateTime
} from "../../../../utils/DateUtils";

import { manageWhItemData } from '../../../../utils/WarehouseUtils';

const Form = ({ callInitialize, mode, name, whDocNo }) => {
  const [formMasterList, setFormMasterList] = useState(whDocMasterModel());
  const [formDetailList, setFormDetailList] = useState([]);
  const [itemDataList, setItemDataList] = useState([]);
  const [whDataList, setWhDataList] = useState([]);
  const [arDataList, setArDataList] = useState([]);

  // การเลือกคลังจากหน้าจอ
  const [selectedWarehouseFrom, setSelectedWarehouseFrom] = useState(null);

  // เก็บสายส่ง
  const [dlLineName, setDlLineName] = useState("ไม่ระบุสายส่ง");

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    const whDataList = await getDataWithComp('Tb_Set_WH', `AND Flag_Vansale = 'N' AND WH_Status = 'Y' ORDER BY Flag_Vansale, WH_Name ASC`);
    if (whDataList && whDataList.length > 0) {
      setWhDataList(whDataList);
    }

    const arDataList = await getDataWithComp('Tb_Set_AR', 'ORDER BY AR_Code ASC');
    if (arDataList && arDataList.length > 0) {
      setArDataList(arDataList);
    }

    // สำหรับ View เข้ามาเพื่อแก้ไขข้อมูล
    if (mode === 'U') {
      await getModelByNo(arDataList);
    }

    // โรงน้ำแข็ง ต้องการ Default คลัง "สโตร์ลัง"
    if (localStorage.getItem("company") === "2") {
      await handleChangeWarehouse("66");
    }
  };

  const getModelByNo = async (arDataList) => {
    try {
      const fromDatabase = await getDataWithComp('WHDoc_H', `AND WHDoc_No = '${whDocNo}'`);

      if (!fromDatabase) {
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      // ค้นหาข้อมูลผู้ขายด้วย AR_ID
      const fromViewAr = arDataList.find(
        (ap) => ap.AR_Id === fromDatabase[0].WHDoc_Cust_Id
      );

      if (!fromViewAr) {
        throw new Error("ไม่พบข้อมูลลูกค้า");
      }

      // ค้นหาสายตามลูกค้าที่เลือกด้วยจ้า
      await findDeliveryLineNameById(fromDatabase[0].WHDoc_Cust_Id);

      // ฟังก์ชันดึงข้อมูล itemOnHand
      const getOnHand = async (whId, itemId) => {
        const itemOnHand = await getDataWithComp('API_1101_WH_ITEM_ONHAND', `AND WH_Id = ${parseCurrency(whId)} AND Item_Id = ${parseCurrency(itemId)}`);
        return itemOnHand[0].Item_Onhand;
      };

      // ฟังก์ชันสร้างแถวใหม่
      const createNewRow = (index, itemSelected, itemOnHand) => {
        return {
          ...whDocDetailModel(index + 1),
          dtId: itemSelected.DT_Id,
          whDocId: itemSelected.WHDoc_Id || null,
          line: itemSelected.Line || null,
          itemId: itemSelected.Item_Id || null,
          itemCode: itemSelected.Item_Code || null,
          itemName: itemSelected.Item_Name || null,
          itemOnHand: itemOnHand || null,
          itemQty: itemSelected.Item_Qty ? formatCurrency(itemSelected.Item_Qty) : null,
          itemIncrease: null,
          itemDecrease: itemSelected.Item_Qty || null,
          itemOrder: null,
          itemBalance: parseCurrency(itemOnHand) - parseCurrency(itemSelected.Item_Qty),
          itemUnit: itemSelected.Item_Unit || null,
          itemPriceUnit: itemSelected.Item_Price_Unit || null,
          itemDiscount: null,
          itemDisType: null,
          itemTotal: itemSelected.Item_Total || null,
          docType: itemSelected.Doc_Type || null,
          refDocId: itemSelected.Ref_DocID || null,
          refDocNo: itemSelected.Ref_DocNo || null,
          itemIsReturn: parseCurrency(itemSelected.Item_Is_Return) || 0,
          itemReturnDate: formatThaiDateUi(itemSelected.Item_Return_Date) || null
        };
      };

      // ค้นหาข้อมูลของ Detail ด้วย WHDoc_Id
      const fromDetail = await getDataWithComp('API_1002_WHDOC_D', `AND WHDoc_Id = ${fromDatabase[0].WHDoc_Id} AND Item_Is_Return <> 1 ORDER BY Line ASC`);

      if (fromDetail.length > 0) {
        // สร้าง Promises สำหรับ itemOnHand
        const itemOnHandPromises = fromDetail.map(item => getOnHand(fromDatabase[0].F_WH_Id, item.Item_Id));

        // รอ Promises
        const itemOnHandResults = await Promise.all(itemOnHandPromises);

        // สร้าง newFormDetails โดยใช้ itemOnHandResults
        const newFormDetails = fromDetail.map((item, index) => createNewRow(formDetailList.length + index, item, itemOnHandResults[index]));

        await handleChangeWarehouse(String(fromDatabase[0].F_WH_Id), 'FROM');

        setFormDetailList(newFormDetails);

        const data = fromDatabase[0];

        setFormMasterList({
          whDocId: data.WHDoc_Id,
          whDocNo: data.WHDoc_No,
          whDocType: data.WHDoc_Type,
          whDocCustId: data.WHDoc_Cust_Id,
          whDocCustCode: fromViewAr.AR_Code,
          whDocCustName: fromViewAr.AR_Name,
          whDocDate: formatThaiDateUi(data.WHDoc_Date),
          whDocTransDate: formatThaiDateUi(data.WHDoc_TransDate),
          whDocCreatedDate: setCreateDateTime(data.WHDoc_CreatedDate),
          whDocCreatedBy: data.WHDoc_CreatedBy,
          whDocStatus: data.WHDoc_Status,
          whDocSeq: data.WHDoc_SEQ,
          whDocRemark: data.WHDoc_Remark,
          whDocCompId: data.Comp_Id,
          whDocShowFront: data.WHDoc_ShowFront,
          refDocId: data.Ref_DocID,
          refDoc: null,
          refDocDate: null
        });

      } else {
        getAlert('FAILED', `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${fromDatabase[0].WHDoc_No} กรุณาตรวจสอบและลองอีกครั้ง`);
      }
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  const handleChangeMaster = (e) => {
    const { name, value } = e.target;
    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeDateMaster = (value, name) => {
    // ตรวจสอบว่า value เป็น moment object หรือไม่
    const newValue = value && value instanceof moment ? value.format('YYYY-MM-DD') : value;
    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: formatDateOnChange(newValue),
    }));
  };

  const handleChangeWarehouse = async (value) => {
    // เคลียค่าตอนกดย้ายคลัง
    if (mode === 'I') {
      setFormDetailList([]);
    }

    // ดึงข้อมูลจาก Tb_Set_Item
    const itemDataList = await getDataWithComp('Tb_Set_Item', `AND Item_Group IN ('5','15') AND Item_Status = 'Y' ORDER BY Item_Code ASC`);

    if (itemDataList && itemDataList.length > 0) {
      setItemDataList(itemDataList);
    }

    // ดึงข้อมูลจาก API_1101_WH_ITEM_ONHAND
    const itemOnHandList = await getDataWithComp('API_1101_WH_ITEM_ONHAND', `AND WH_Id = ${parseCurrency(value)} ORDER BY Item_Code ASC`);

    if (itemOnHandList && itemOnHandList.length > 0 && itemDataList && itemDataList.length > 0) {
      // กรอง itemOnHandList โดยเช็ค Item_Id ที่มีใน itemDataList
      const filteredItemOnHandList = itemOnHandList.filter(itemOnHand =>
        itemDataList.some(itemData => itemData.Item_Id === itemOnHand.Item_Id)
      );

      setItemDataList(filteredItemOnHandList);
    }

    setSelectedWarehouseFrom(value);
  };

  const handleQuantityChange = (index, type, value, onHand) => {
    // ดักค่าเพื่อให้ส่งมาอย่างถูกต้อง (จริงๆแล้วแทบไม่ได้ใช้)
    if (type !== 'decrease') {
      getAlert("FAILED", "พบข้อผิดพลาดในการดำเนินการ กรุณารีเฟชรแล้วลองใหม่");
    }

    // ตรวจสอบว่าค่าที่กรอกเข้ามาเป็นตัวเลขหรือตัวเลขที่มีจุดทศนิยม
    if (!/^\d*\.?\d*$/.test(value)) {
      //getAlert("FAILED", "กรุณากรอกเฉพาะตัวเลขเท่านั้น");
      return;
    }

    // หากผู้ใช้กรอกจุดทศนิยมอย่างเดียว (เช่น ".") ให้คงค่าเดิมไว้ก่อน
    if (value === ".") {
      const updatedList = [...formDetailList];
      updatedList[index].itemDecrease = value;
      updatedList[index].itemBalance = parseCurrency(onHand);
      setFormDetailList(updatedList);
      return;
    }

    const updatedList = [...formDetailList];

    // ดักไม่ให้ปรับปรุงเกินกว่าสินค้าคงเหลือ เฉพาะตอนปรับลดสินค้า
    if (value > onHand) {
      getAlert("FAILED", "กรุณาระบุจำนวนไม่เกินคงเหลือ");
      updatedList[index].itemDecrease = null;
      updatedList[index].docType = "AO";
      updatedList[index].itemBalance = parseCurrency(onHand);
      setFormDetailList(updatedList);
      return;
    }

    updatedList[index].docType = "AO";
    updatedList[index].itemDecrease = parseCurrency(value);
    updatedList[index].itemQty = parseCurrency(value);
    updatedList[index].itemBalance = parseCurrency(onHand) - parseCurrency(value);

    setFormDetailList(updatedList);
  };

  const handleFocus = (index) => {
    const updatedList = [...formDetailList];
    console.debug(updatedList);
    updatedList[index].itemDecrease = parseCurrency(updatedList[index].itemDecrease) || 0;
    setFormDetailList(updatedList);
  };

  const handleBlur = (index) => {
    const updatedList = [...formDetailList];
    updatedList[index].itemDecrease = formatCurrency(updatedList[index].itemDecrease);
    setFormDetailList(updatedList);
  };

  // SET AR
  const [showArModal, setShowArModal] = useState(false);
  const handleArShow = () => setShowArModal(true);
  const handleArClose = () => setShowArModal(false);
  const onRowSelectAr = async (arSelected) => {
    try {
      setFormMasterList({
        ...formMasterList,
        whDocCustId: arSelected.AR_Id,
        whDocCustCode: arSelected.AR_Code,
        whDocCustName: arSelected.AR_Name,
        arAdd1: arSelected.AR_Add1,
        arAdd2: arSelected.AR_Add2,
        arAdd3: arSelected.AR_Add3,
        arProvince: arSelected.AR_Province,
        arZipcode: arSelected.AR_Zipcode,
        arTaxNo: arSelected.AR_TaxNo,
      });

      // ค้นหาสายตามลูกค้าที่เลือกด้วยจ้า
      await findDeliveryLineNameById(arSelected.AR_Id);

      handleArClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // SET ITEM
  const [showItemModal, setShowItemModal] = useState(false);
  const handleItemShow = () => setShowItemModal(true);
  const handleItemClose = () => setShowItemModal(false);
  const onRowSelectItem = (itemsSelected) => {
    try {
      /// ใช้ Set เพื่อกรอง Item_Id ที่ซ้ำกัน
      const uniqueItems = Array.from(
        new Set(itemsSelected.map(item => item.Item_Id))
      ).map(id => {
        return itemsSelected.find(item => item.Item_Id === id);
      });

      // อัปเดตรายการโดยคงค่าของสินค้าที่เคยมีอยู่
      const updatedFormDetailList = uniqueItems.map((itemSelected) => {
        // ค้นหาว่ามีสินค้าอยู่ใน formDetailList เดิมหรือไม่
        const existingItem = formDetailList.find(item => item.itemId === itemSelected.Item_Id);

        return {
          line: existingItem?.line || null,
          itemId: itemSelected.Item_Id,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty: existingItem ? formatCurrency(existingItem.itemQty || 0) : formatCurrency(1),
          itemDecrease: existingItem ? formatCurrency(existingItem.itemDecrease || 0) : formatCurrency(1),
          itemUnit: existingItem ? existingItem.itemUnit : itemSelected.Item_Unit_ST,
          itemPriceUnit: existingItem ? existingItem.itemPriceUnit : formatCurrency(itemSelected.Item_Cost || 0),
          itemOnHand: existingItem ? existingItem.itemOnHand : formatCurrency(itemSelected.Item_Onhand || 0),
          itemTotal: existingItem ? existingItem.itemTotal : 0,
          docType: "AO",
          itemIsReturn: 0,
          itemReturnDate: formatThaiDateUi(moment())
        };
      });

      setFormDetailList(updatedFormDetailList);
      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error);
    }
  };
  const handleRemoveRow = (index) => {
    const newList = formDetailList.filter((_, i) => i !== index);
    setFormDetailList(newList);
  };

  const findDeliveryLineNameById = async (arId) => {
    const deliveryLine = await getDataWithComp('View_DL_Line', `AND DL_AR_Id = ${arId}`);

    if (deliveryLine && deliveryLine.length > 0) {
      setDlLineName(deliveryLine[0].DL_LineName);
    }
  };

  const handleSubmit = async () => {
    try {
      // ทดสอบหน่วงเวลาก่อนบันทึก (ทดสอบป้องกันการซ้ำของ Doc_No)
      await randomDelay();

      const findMaxIbNo = await getDataWithComp('WHDoc_H', `AND WHDoc_Type = '5' ORDER BY WHDoc_No DESC`);
      const maxIb = getMaxIbNo(findMaxIbNo);
      let newMaxIb = maxIb;

      if (selectedWarehouseFrom === null) {
        getAlert("FAILED", "กรุณาเลือกจากคลัง");
        return;
      }

      if (formMasterList.whDocCustId === null) {
        getAlert("FAILED", "กรุณาเลือกไปลูกค้า");
        return;
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้าที่จะยืม");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่าภายใน formDetailList
      for (const item of formDetailList) {
        if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
          getAlert("FAILED", `กรุณากรอกจำนวนยืมของลังน้ำแข็ง : ${item.itemName}`);
          return; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
        }
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        wh_doc_no: newMaxIb,
        wh_doc_type: parseCurrency("5", 10),
        wh_doc_cust_id: parseCurrency(formMasterList.whDocCustId, 10),
        wh_doc_date: formatStringDateToDate(formMasterList.whDocDate),
        wh_doc_trans_date: formatStringDateToDate(formMasterList.whDocTransDate),
        wh_doc_created_date: formatThaiDateUiToDate(formMasterList.whDocCreatedDate),
        wh_doc_created_by: formMasterList.whDocCreatedBy,
        wh_doc_status: parseCurrency("1", 10),
        wh_doc_seq: formatDateTime(new Date()),
        wh_doc_remark: formMasterList.whDocRemark,
        wh_doc_comp_id: formMasterList.whDocCompId,
        wh_doc_show_front: null,
        ref_doc_id: formMasterList.refDocId,
        f_wh_id: selectedWarehouseFrom,
        f_zone_id: formMasterList.fZoneId,
        f_lt_id: formMasterList.fLtId,
        t_wh_id: parseCurrency(formMasterList.whDocCustId, 10),
        t_zone_id: formMasterList.fZoneId,
        t_lt_id: formMasterList.fLtId,
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(`${process.env.REACT_APP_API_URL}/api/create-wh-doc-h`, formMasterData, {
        headers: { key: process.env.REACT_APP_ANALYTICS_KEY }
      });

      if (response.data.status === 'OK') {
        const getWhDocIdResponse = await Axios.post(`${process.env.REACT_APP_API_URL}/api/get-by-wh-doc-no`, {
          table: 'WHDoc_H',
          wh_doc_no: formMasterData.wh_doc_no,
          comp_id: window.localStorage.getItem('company')
        }, {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY }
        });

        if (getWhDocIdResponse && getWhDocIdResponse.data.length > 0) {
          const whDocId = parseCurrency(getWhDocIdResponse.data[0].WHDoc_Id, 10);
          let line = 1;

          for (const item of formDetailList) {
            const formDetailData = {
              wh_doc_id: whDocId,
              line: line,
              item_id: item.itemId,
              item_code: item.itemCode,
              item_name: item.itemName,
              item_qty: parseCurrency(item.itemQty),
              item_unit: item.itemUnit,
              item_price_unit: parseCurrency(item.itemPriceUnit),
              item_total: parseCurrency(item.itemTotal),
              doc_type: item.docType,
              ref_doc_id: item.refDocId,
              item_is_return: item.itemIsReturn,
              item_return_date: formatStringDateToDate(item.itemReturnDate)
            };
            line++;

            // ย้ายออก
            await manageWhItemData(
              item.itemId, // Item ไอดีของสิ่งนั้นๆ
              item.itemCode, // Item โค้ดของสิ่งนั้นๆ
              item.itemName, // ชื่อ Item นั้นๆ
              selectedWarehouseFrom, // WarehouseID ของไอเทม
              "AO", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
              parseCurrency(item.itemQty), // ค่าจำนวนที่กรอกจากหน้าจอ
              whDocId, // ไอดีเอกสาร
              newMaxIb, // เลขเอกสาร
              newMaxIb, // เลขเอกสารอ้างอิง
              `ยืมสินค้า` // หมายเหตุ
            );

            // // ย้ายเข้า
            // await manageWhItemData(
            //   item.itemId, // Item ไอดีของสิ่งนั้นๆ
            //   item.itemCode, // Item โค้ดของสิ่งนั้นๆ
            //   item.itemName, // ชื่อ Item นั้นๆ
            //   selectedWarehouseTo, // WarehouseID ของไอเทม
            //   "TI", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
            //   parseCurrency(item.itemQty), // ค่าจำนวนที่กรอกจากหน้าจอ
            //   whDocId, // ไอดีเอกสาร
            //   newMaxOd, // เลขเอกสาร
            //   formMasterList.refDoc, // เลขเอกสารอ้างอิง
            //   formMasterList.whDocRemark // หมายเหตุ
            // );

            // เรียก API สร้างเอกสาร
            await Axios.post(`${process.env.REACT_APP_API_URL}/api/create-wh-doc-d`, formDetailData, {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            });
          }
        }

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleUpdate = async () => {
    try {
      if (selectedWarehouseFrom === null) {
        getAlert("FAILED", "กรุณาเลือกจากคลัง");
        return;
      }

      if (formMasterList.whDocCustId === null) {
        getAlert("FAILED", "กรุณาเลือกไปลูกค้า");
        return;
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้าที่จะยืม");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่าภายใน formDetailList
      for (const item of formDetailList) {
        if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
          getAlert("FAILED", `กรุณากรอกจำนวนยืมของลังน้ำแข็ง : ${item.itemName}`);
          return; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
        }
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        wh_doc_no: formMasterList.whDocNo,
        wh_doc_type: formMasterList.whDocType,
        wh_doc_cust_id: parseCurrency(formMasterList.whDocCustId, 10),
        wh_doc_date: formatStringDateToDate(formMasterList.whDocDate),
        wh_doc_trans_date: formatStringDateToDate(formMasterList.whDocTransDate),
        wh_doc_created_date: formatThaiDateUiToDate(formMasterList.whDocCreatedDate),
        wh_doc_created_by: formMasterList.whDocCreatedBy,
        wh_doc_status: formMasterList.whDocStatus,
        wh_doc_seq: formMasterList.whDocSeq,
        wh_doc_remark: formMasterList.whDocRemark,
        wh_doc_comp_id: formMasterList.whDocCompId,
        wh_doc_show_front: formMasterList.whDocShowFront,
        ref_doc_id: formMasterList.refDocId,
        f_wh_id: selectedWarehouseFrom,
        f_zone_id: formMasterList.fZoneId,
        f_lt_id: formMasterList.fLtId,
        t_wh_id: parseCurrency(formMasterList.whDocCustId, 10),
        t_zone_id: formMasterList.fZoneId,
        t_lt_id: formMasterList.fLtId,
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(`${process.env.REACT_APP_API_URL}/api/update-wh-doc-h`, formMasterData, {
        headers: { key: process.env.REACT_APP_ANALYTICS_KEY }
      });

      if (response.data.status === 'OK') {

        const findOldIcebox = await getData('API_1002_WHDOC_D', `WHDoc_Id = ${formMasterList.whDocId}`);

        if (findOldIcebox && findOldIcebox.length > 0) {
          for (const iceboxData of findOldIcebox) {
            // ย้ายเข้า
            await manageWhItemData(
              iceboxData.Item_Id, // Item ไอดีของสิ่งนั้นๆ
              iceboxData.Item_Code, // Item โค้ดของสิ่งนั้นๆ
              iceboxData.Item_Name, // ชื่อ Item นั้นๆ
              iceboxData.F_WH_Id, // WarehouseID ของไอเทม
              "AI", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
              parseCurrency(iceboxData.Item_Qty), // ค่าจำนวนที่กรอกจากหน้าจอ
              iceboxData.WHDoc_Id, // ไอดีเอกสาร
              formMasterList.whDocNo, // เลขเอกสาร
              formMasterList.whDocNo, // เลขเอกสารอ้างอิง
              `แก้ไขใบ : ${formMasterList.whDocNo}` // หมายเหตุ
            );
          }
        }

        // ลบข้อมูลเดิมก่อนจะเริ่มการบันทึกใหม่
        await deleteData('WHDoc_D', `WHERE WHDoc_Id = ${formMasterList.whDocId}`);

        const whDocId = parseCurrency(formMasterList.whDocId, 10);
        let line = 1;

        for (const item of formDetailList) {
          const formDetailData = {
            wh_doc_id: whDocId,
            line: line,
            item_id: item.itemId,
            item_code: item.itemCode,
            item_name: item.itemName,
            item_qty: parseCurrency(item.itemQty),
            item_unit: item.itemUnit,
            item_price_unit: parseCurrency(item.itemPriceUnit),
            item_total: parseCurrency(item.itemTotal),
            doc_type: item.docType,
            ref_doc_id: item.refDocId,
            item_is_return: item.itemIsReturn,
            item_return_date: formatStringDateToDate(item.itemReturnDate)
          };
          line++;

          // ย้ายออก
          await manageWhItemData(
            item.itemId, // Item ไอดีของสิ่งนั้นๆ
            item.itemCode, // Item โค้ดของสิ่งนั้นๆ
            item.itemName, // ชื่อ Item นั้นๆ
            selectedWarehouseFrom, // WarehouseID ของไอเทม
            "AO", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
            parseCurrency(item.itemQty), // ค่าจำนวนที่กรอกจากหน้าจอ
            formMasterList.whDocId, // ไอดีเอกสาร
            formMasterList.whDocNo, // เลขเอกสาร
            formMasterList.whDocNo, // เลขเอกสารอ้างอิง
            `ยืมสินค้า` // หมายเหตุ
          );

          // เรียก API เพื่อสร้างเอกสารทีละรายการ
          await Axios.post(`${process.env.REACT_APP_API_URL}/api/create-wh-doc-d`, formDetailData, {
            headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
          });
        }

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleCancel = async () => {
    try {
      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        wh_doc_no: formMasterList.whDocNo,
        wh_doc_status: parseCurrency("13", 10),
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-wh-doc-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (response.data.status === 'OK') {
        const findOldIcebox = await getData('API_1002_WHDOC_D', `WHDoc_Id = ${formMasterList.whDocId}`);
        if (findOldIcebox && findOldIcebox.length > 0) {
          for (const iceboxData of findOldIcebox) {
            // ย้ายเข้า
            await manageWhItemData(
              iceboxData.Item_Id, // Item ไอดีของสิ่งนั้นๆ
              iceboxData.Item_Code, // Item โค้ดของสิ่งนั้นๆ
              iceboxData.Item_Name, // ชื่อ Item นั้นๆ
              iceboxData.F_WH_Id, // WarehouseID ของไอเทม
              "AI", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
              parseCurrency(iceboxData.Item_Qty), // ค่าจำนวนที่กรอกจากหน้าจอ
              iceboxData.WHDoc_Id, // ไอดีเอกสาร
              formMasterList.whDocNo, // เลขเอกสาร
              formMasterList.whDocNo, // เลขเอกสารอ้างอิง
              `ยกเลิกใบ : ${formMasterList.whDocNo}` // หมายเหตุ
            );
          }
        }
      }

      // callInitialize();
      // getAlert(response.data.status, response.data.message);
      window.location.reload();
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  return <>
    <Breadcrumbs page={whDocNo} items={[
      { name: 'คลังสินค้า', url: '/Warehouse' },
      { name: name, url: '/icebox' },
      { name: mode === 'U' ? "เรียกดู" + name : "สร้าง" + name, url: '#' }
    ]} />
    <div className="body">
      <div class="container-fluid my-4">
        <div className="row mb-1">
          <div className="col-4">
            <div className="d-flex">
              <label>วันที่เอกสาร : </label>
              <Datetime
                className="input-spacing-input-date"
                name="whDocDate"
                value={formMasterList.whDocDate || null}
                onChange={(date) => handleChangeDateMaster(date, 'whDocDate')}
                dateFormat="DD-MM-YYYY"
                timeFormat={false}
                inputProps={{ readOnly: true, disabled: mode === 'U' }}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex">
              <label>จากคลัง : </label>
              <select
                class="form-select"
                value={selectedWarehouseFrom}
                disabled={mode === 'U' ? true : false}
                onChange={(e) => handleChangeWarehouse(e.target.value)}>
                <option value={null}>
                  กรุณาระบุคลัง
                </option>
                {whDataList.map((warehouse) => (
                  <option
                    key={warehouse.WH_Id}
                    value={warehouse.WH_Id}
                  >
                    {warehouse.WH_Name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex">
              <label>สร้างโดย : </label>
              <input
                type="text"
                className="form-control input-spacing"
                value={formMasterList.whDocCreatedBy}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mb-1">
          <div className="col-4">
            <div className="d-flex">
              <label>วันที่จัดส่ง : </label>
              <Datetime
                className="input-spacing-input-date"
                name="whDocTransDate"
                value={formMasterList.whDocTransDate || null}
                onChange={(date) => handleChangeDateMaster(date, 'whDocTransDate')}
                dateFormat="DD-MM-YYYY"
                timeFormat={false}
                inputProps={{ readOnly: true, disabled: formMasterList.refDocId !== null }}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex">
              <label>ไปที่ลูกค้า :</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="apCode"
                  value={
                    (formMasterList.whDocCustCode || '')
                    + " " +
                    (formMasterList.whDocCustName || '')
                  }
                  onChange={handleChangeMaster}
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleArShow}
                  disabled={mode === 'U' ? true : false}>
                  <i className="fas fa-search"></i>
                </button>
              </div>
              <ArModal
                showArModal={showArModal}
                handleArClose={handleArClose}
                arDataList={arDataList}
                onRowSelectAr={onRowSelectAr}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex">
              <label className="">วันที่สร้าง : </label>
              <input
                type="text"
                className="form-control input-spacing"
                value={formMasterList.whDocCreatedDate}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mb-1">
          <div className="col-4">
            <div className="d-flex">
              <label>หมายเหตุ : </label>
              <input
                type="text"
                className="form-control input-spacing"
                name="whDocRemark"
                value={formMasterList.whDocRemark || ''}
                onChange={handleChangeMaster}
                disabled={formMasterList.refDocId !== null} />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>สายส่ง</label>
              <input
                type="text"
                className="form-control input-spacing"
                value={dlLineName || "ไม่ระบุสายส่ง"}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mb-1">
          <div className="col-4">
            {/* <div className="d-flex">
              <label>วันที่เอกสารอ้างอิง : </label>
              <input
                type="text"
                className="form-control input-spacing"
                name="refDocDate"
                value={formMasterList.refDocDate || ''}
                disabled={true}
              />
            </div> */}
          </div>
          <div className="col-4" />
        </div>
      </div>
      <hr />
    </div>
    <div className="container-fluid my-3">
      <div className="row">
        <div className="col-12">
          <ItemWhTable
            mode={mode}
            showItemModal={showItemModal}
            handleItemClose={handleItemClose}
            itemDataList={itemDataList}
            onRowSelectItem={onRowSelectItem}
            formDetailList={formDetailList}
            handleItemShow={handleItemShow}
            handleQuantityChange={handleQuantityChange}
            handleFocus={handleFocus}
            handleBlur={handleBlur}
            handleRemoveRow={handleRemoveRow}
            formatCurrency={formatCurrency}
            disabled={selectedWarehouseFrom === null}
          />
          <FormAction
            onSubmit={handleSubmit}
            onUpdate={handleUpdate}
            onCancel={handleCancel}
            mode={mode}
            disabled={formMasterList.refDocId !== null}
            footer={true}
          />
        </div>
      </div>
    </div>
  </>
};

export default Form;